import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import Acquirers from "./Components/Acquirers";
import { useTranslation } from "react-i18next";

/**
 * @namespace Acquirers
 */

const AcquirersPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.acquirers") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <Acquirers />
    </>
  );
};

export default AcquirersPage;
